module.exports = __webpack_public_path__ + "img/assetOrange.a522a4ae.png";